// extracted by mini-css-extract-plugin
export default {"nav":"nfMLizVgMIDbB2PRjuem","logo":"vULLgsyMe1bdWZbnLXcx"};